import React from 'react';
import { Box, DataTable } from '../../../../common/components';
import { applyFilter } from '../../../../common/components/DataTable/redux/dataTableActions';
import { TableHeaderColumn } from 'react-bootstrap-table';
import { Col, ControlLabel, FormControl, Row } from 'react-bootstrap';
import { push } from 'react-router-redux';
import formatDateTime from '../../../../helpers/formatDateTime';
import selectTheme from '../../../../helpers/selectTheme';
import Select from 'react-select';
import AsyncSelectMenu from '../../../../common/components/SelectMenu/AsyncSelectMenu';
import { connect } from 'react-redux';

const formatB2bChannel = (metadata) => {
  const brokerChannel = metadata?.broker_channel;
  if (brokerChannel === 'jtc-brokers') {
    return 'Aneevo';
  }
  if (brokerChannel === 'jtc-b2b') {
    return 'JTC';
  }

  return '';
};

const BrokerList = ({ goTo, applyFilter }) => {
  const handleRowClick = (row) => {
    goTo(`/admin/brokers/${row.id}`);
  };

  const handleStatusUpdate = (option) => {
    applyFilter('brokers', 'filter[status]', option ? option.value : '');
  };

  const handleOrganisationFilterUpdate = (option) => {
    applyFilter('brokers', 'filter[organisation]', option ? option.value : '');
  };

  const handleSearchUpdate = (event) => {
    applyFilter('brokers', 'filter[broker_name]', event.target.value);
  };

  return (
    <>
      <Box>
        <Row>
          <Col sm={4}>
            <ControlLabel>Search</ControlLabel>
            <FormControl onChange={handleSearchUpdate} />
          </Col>
          <Col sm={4}>
            <ControlLabel>Organisation</ControlLabel>
            <AsyncSelectMenu
              url={'/organisations?'}
              optionValuePath={'id'}
              autoFilters={[{ type: 'type', match: 'Broker' }]}
              onChangeCallback={handleOrganisationFilterUpdate}
              isClearable
            />
          </Col>
          <Col sm={4}>
            <ControlLabel>Status</ControlLabel>
            <Select
              theme={(theme) => selectTheme(theme)}
              options={[
                { label: 'Active', value: 'active' },
                { label: 'Inactive', value: 'inactive' },
                { label: 'Pending', value: 'pending' },
              ]}
              isClearable
              onChange={handleStatusUpdate}
            />
          </Col>
        </Row>
      </Box>

      <Box>
        <DataTable
          source="/brokers"
          name="brokers"
          autoFilter={'broker'}
          autoFilterType="filter[broker_type]"
          showTotal
          onRowSelect={handleRowClick}
        >
          <TableHeaderColumn dataField="id" isKey hidden />

          <TableHeaderColumn dataField="name">Name</TableHeaderColumn>
          <TableHeaderColumn dataField="metadata" dataFormat={formatB2bChannel}>
            Default Channel
          </TableHeaderColumn>

          <TableHeaderColumn
            dataField="status"
            //dataFormat={brokerStatus}
            dataSort
          >
            Status
          </TableHeaderColumn>

          <TableHeaderColumn
            dataField="created_at"
            dataFormat={formatDateTime}
            width={'180px'}
            dataSort
          >
            Created
          </TableHeaderColumn>
        </DataTable>
      </Box>
    </>
  );
};
export default connect(
  null,
  {
    applyFilter: applyFilter,
    goTo: push,
  },
)(BrokerList);
